export const  columns = [
    {
        title: '#',
        dataIndex: 'boxTemplateId',
        key: 'boxTemplateId',
        width: 50,
        customRender: (text, record, index) => {
            return index + 1
        },
    },
    {
        title: '模板名称',
        dataIndex: 'templateName',
        key: 'templateName',
    },
    {
        title: '规格',
        dataIndex: 'width',
        key: 'width',
        customRender: (text, record, index) => {
            return `长：${record.length} cm、宽：${record.width} cm、高：${record.height} cm`
        },
    },
    // {
    //     title: '模板状态',
    //     dataIndex: 'status',
    //     key: 'status',
    //     customRender: (text, record, index) => {
    //         return {0: '启用 ', 1: '禁用'}[text]
    //     },
    // },
    // {
    //     title: '创建时间',
    //     dataIndex: 'createTime',
    //     key: 'createTime'
    // },
    // {
    //     title: '创建人',
    //     dataIndex: 'creater',
    //     key: 'creater'
    // },
    {
        title: '操作',
        key: 'action',
        dataIndex: 'templateCode',
        width: 200,
        scopedSlots: {
            customRender: 'action'
        }
    }
]